import axios from "axios";
// import { store } from "../Redux/Store/Store"; // Import your Redux store
import { setErrorMessage } from "../Redux/Slice/Common/SelectedTabSlice"; // Assuming you have a slice to manage error messages
import URLDATA from "../Config";
// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: URLDATA.API_URI, // Your base URL
  timeout: 60000, // Timeout for requests
});

const logoutUser = async () => {
  localStorage.clear();
  window.location.href = "/";
};

function errorHandler(requestError) {
  if (axios.isAxiosError(requestError)) {
    if (requestError?.response?.status == 423) {
      logoutUser();
    }
    if(requestError?.code == "ECONNABORTED" || requestError?.code == "ETIMEDOUT"){
      return Promise.reject({
        message: {
          success: false,
          error: {
            message: "Unable to connect to the server. Please check your internet connection and try again.",
          },
        },
      });
    } else if (requestError?.response && requestError?.response?.data) {
      return Promise.reject({ message: requestError?.response?.data });
    }
    let message = requestError?.message;
    if (
      requestError.code === "ERR_NETWORK" ||
      requestError.message === "Network Error"
    ) {
      message = "Unable to connect to the server. Please check your internet connection and try again.";
    }
    return Promise.reject({
      message: {
        success: false,
        error: {
          message: message ?? "Something went wrong, Please try again later!",
        },
      },
    });
  }
  return Promise.reject(requestError);
}

const getToken = () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const token = userData ? userData.access_token : "";
  return token;
};
// Request interceptor (optional, if you want to include auth tokens, etc.)
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken(); // Or however you store the token
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (requestError) => {
    return errorHandler(requestError);
  }
);

// Response interceptor to catch session expiry or other errors
export const addInterceptors = (dispatch) => {
  axiosInstance.interceptors.response.use(
    (response) => {
      return response; // Return the response if it’s successful
    },
    (error) => {
      // Check for session expiry (status code 401)
      if (
        error.response &&
        (error.response.status === 423 || error.response.status === 403)
      ) {
        // Dispatch an action to show an error message or handle session expiry
        dispatch(
          setErrorMessage("Session Details invalid. Please login again.")
        );
      }

      // Return any other errors (like network issues, etc.)
      return Promise.reject(error);
    }
  );
};

export default axiosInstance;
